// extracted by mini-css-extract-plugin
export default {"feature__container":"feature_section_feature__container__LPRo4","feature__title":"feature_section_feature__title__X0tCY"};